import * as React from "react"
export const Svg_054 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={58}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M1.82 47.571A6.017 6.017 0 0 0 0 51.891c0 1.632.646 3.166 1.82 4.32A6.228 6.228 0 0 0 6.214 58c1.66 0 3.22-.635 4.395-1.79l1.496-1.47-8.789-8.64-1.496 1.471Z"
      />
      <path
        fill="url(#c)"
        d="m15.402 34.22-4.752 4.671 8.788 8.64 4.752-4.672a25.424 25.424 0 0 1-4.934-3.788 25.099 25.099 0 0 1-3.854-4.851Z"
      />
      <path
        fill="url(#d)"
        d="M5.755 43.694 8.2 41.291l8.787 8.639-2.444 2.402-8.787-8.638Z"
      />
      <path
        fill="url(#e)"
        d="M59 21.48C59 9.636 49.198 0 37.15 0 25.102 0 15.3 9.636 15.3 21.48c0 11.843 9.802 21.48 21.85 21.48C49.198 42.96 59 33.322 59 21.48ZM37.15 38.246c-9.405 0-17.057-7.522-17.057-16.767 0-9.246 7.652-16.768 17.057-16.768 9.406 0 17.057 7.522 17.057 16.768 0 9.245-7.652 16.767-17.057 16.767Z"
      />
      <path
        fill="url(#f)"
        d="M37.15 8.11c-7.499 0-13.6 5.998-13.6 13.37 0 7.372 6.101 13.369 13.6 13.369 7.5 0 13.6-5.997 13.6-13.37 0-7.371-6.101-13.369-13.6-13.369Zm-1.609 19.9-6.401-6.293 2.444-2.403 3.957 3.89 7.175-7.053 2.445 2.403-9.62 9.456Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={2.799}
        x2={8.408}
        y1={47.885}
        y2={57.119}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.781}
        x2={20.055}
        y1={36.217}
        y2={46.545}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={7.639}
        x2={12.683}
        y1={44.434}
        y2={42.489}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={25.406}
        x2={45.654}
        y1={6.444}
        y2={39.778}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={29.84}
        x2={42.443}
        y1={12.121}
        y2={32.869}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v58H0z" />
      </clipPath>
    </defs>
  </svg>
)